module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-213.e4406dbe.svg";